import { render, staticRenderFns } from "./DecisionPurposeListTable.vue?vue&type=template&id=4af2078e&scoped=true&"
import script from "./DecisionPurposeListTable.vue?vue&type=script&lang=js&"
export * from "./DecisionPurposeListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2078e",
  null
  
)

export default component.exports